import type { InterventionReport } from './types';

export function InterventionReportPrintView({
  report,
  photoUrls,
}: {
  report: InterventionReport;
  photoUrls: Record<string, string>;
}) {
  return (
    <article aria-hidden="true" className="hidden print:block print:text-black">
      <header className="border-b-2 border-black pb-4">
        <p className="font-mono text-sm font-bold">{report.reportNumber}</p>
        <h1 className="mt-2 text-2xl font-bold">Intervention report</h1>
        <p className="mt-1">{report.sensorSnapshot.account.name} · {report.sensorSnapshot.account.accountNumber}</p>
      </header>
      <section className="mt-5 grid grid-cols-2 gap-4 text-sm">
        <div><strong>Sensor</strong><p>{report.sensorSnapshot.sensor.name}</p><p className="font-mono">{report.sensorSnapshot.sensor.macId || '—'}</p></div>
        <div><strong>Technician</strong><p>{report.createdByName}</p></div>
        <div><strong>Intervention date</strong><p>{new Date(report.interventionAt).toLocaleString()}</p></div>
        <div><strong>Site / location</strong><p>{report.sensorSnapshot.placement.site?.name || '—'} / {report.sensorSnapshot.placement.location?.name || '—'}</p></div>
      </section>
      <dl className="mt-6 space-y-4 text-sm">
        <div><dt className="font-bold">Reason</dt><dd>{report.reasonCategory}</dd></div>
        <div><dt className="font-bold">Observations</dt><dd className="whitespace-pre-wrap">{report.observations}</dd></div>
        <div><dt className="font-bold">Diagnosis</dt><dd className="whitespace-pre-wrap">{report.diagnosis}</dd></div>
        <div><dt className="font-bold">Work performed</dt><dd className="whitespace-pre-wrap">{report.workPerformed}</dd></div>
        <div><dt className="font-bold">Outcome</dt><dd>{report.outcome}</dd></div>
        {report.followUpAction && <div><dt className="font-bold">Follow-up</dt><dd className="whitespace-pre-wrap">{report.followUpAction}</dd></div>}
      </dl>
      {report.photos.length > 0 && <section className="mt-6"><h2 className="text-lg font-bold">Photos</h2><div className="mt-3 grid grid-cols-2 gap-3">{report.photos.map((photo) => photoUrls[photo.id] ? <img key={photo.id} src={photoUrls[photo.id]} alt="" className="max-h-64 w-full object-contain" /> : null)}</div></section>}
      {report.addenda.length > 0 && <section className="mt-6"><h2 className="text-lg font-bold">Corrections</h2><ol className="mt-3 space-y-3">{report.addenda.map((addendum) => <li key={addendum.id} className="border-l-2 border-black pl-3"><p>{addendum.body}</p><p className="text-xs">{addendum.createdByName} · {new Date(addendum.createdAt).toLocaleString()}</p></li>)}</ol></section>}
    </article>
  );
}
